import * as React from 'react';
import { QuestionFeedbackCreateInput, QuestionFeedbackUpdateInput } from '../generated/globalTypes';
import { useSaveInStore, SaveInStoreOptions } from '../../../shared/useSaveInStore';
import { useCreateQuestionFeedbackCallback } from './useCreateQuestionFeedbackCallback';
import { useUpdateQuestionFeedbackCallback } from './useUpdateQuestionFeedbackCallback';
import { QuestionFeedback } from '../models/QuestionFeedback';

/**
 * Get a callback to save a QuestionFeedback in the store using either a create or update.
 */
export function useSaveQuestionFeedbackCallback(options: SaveInStoreOptions<QuestionFeedback, string> = {}) {
    const [_create, createStatus] = useCreateQuestionFeedbackCallback();
    const create = React.useCallback((model: Partial<QuestionFeedback>) => _create(model as QuestionFeedbackCreateInput), [_create]);

    const [_update, updateStatus] = useUpdateQuestionFeedbackCallback();
    const update = React.useCallback((id: string, changes: Partial<QuestionFeedback>) => _update(id, changes as QuestionFeedbackUpdateInput), [_update]);

    return useSaveInStore(
        [create, createStatus],
        [update, updateStatus],
        options
    );
}
